import axios from 'axios';

// Currency symbols and conversion rates
const CURRENCY_INFO = {
  AE: { symbol: 'AED', code: 'aed', rate: 3.67 },
  AF: { symbol: '؋', code: 'afn', rate: 73.5 },
  AL: { symbol: 'L', code: 'all', rate: 99.5 },
  AM: { symbol: '֏', code: 'amd', rate: 400.3 },
  AN: { symbol: 'ƒ', code: 'ang', rate: 1.79 },
  AO: { symbol: 'Kz', code: 'aoa', rate: 825 },
  AR: { symbol: 'ARS$', code: 'ars', rate: 875 },
  AT: { symbol: '€', code: 'eur', rate: 0.92 },
  AU: { symbol: 'A$', code: 'aud', rate: 1.52 },
  AW: { symbol: 'ƒ', code: 'awg', rate: 1.8 },
  AZ: { symbol: '₼', code: 'azn', rate: 1.7 },
  BA: { symbol: 'KM', code: 'bam', rate: 1.8 },
  BB: { symbol: '$', code: 'bbd', rate: 2 },
  BD: { symbol: '৳', code: 'bdt', rate: 107.5 },
  BE: { symbol: '€', code: 'eur', rate: 0.92 },
  BG: { symbol: 'лв', code: 'bgn', rate: 1.8 },
  BH: { symbol: '.د.ب', code: 'bhd', rate: 0.376 },
  BI: { symbol: 'FBu', code: 'bif', rate: 2830 },
  BM: { symbol: '$', code: 'bmd', rate: 1 },
  BN: { symbol: '$', code: 'bnd', rate: 1.35 },
  BO: { symbol: 'Bs', code: 'bob', rate: 6.91 },
  BR: { symbol: 'R$', code: 'brl', rate: 4.97 },
  BS: { symbol: '$', code: 'bsd', rate: 1 },
  BT: { symbol: 'Nu.', code: 'btn', rate: 83.2 },
  BW: { symbol: 'P', code: 'bwp', rate: 13.5 },
  BY: { symbol: 'Br', code: 'byn', rate: 3.27 },
  BZ: { symbol: 'BZ$', code: 'bzd', rate: 2 },
  CA: { symbol: 'C$', code: 'cad', rate: 1.35 },
  CD: { symbol: 'FC', code: 'cdf', rate: 2480 },
  CH: { symbol: 'CHF', code: 'chf', rate: 0.91 },
  CL: { symbol: 'CLP$', code: 'clp', rate: 970 },
  CN: { symbol: '¥', code: 'cny', rate: 7.24 },
  CO: { symbol: 'COL$', code: 'cop', rate: 3820 },
  CR: { symbol: '₡', code: 'crc', rate: 535 },
  CV: { symbol: '$', code: 'cve', rate: 101.5 },
  CY: { symbol: '€', code: 'eur', rate: 0.92 },
  CZ: { symbol: 'Kč', code: 'czk', rate: 23.17 },
  DE: { symbol: '€', code: 'eur', rate: 0.92 },
  DJ: { symbol: 'Fdj', code: 'djf', rate: 177.7 },
  DK: { symbol: 'kr', code: 'dkk', rate: 6.88 },
  DO: { symbol: 'RD$', code: 'dop', rate: 58.5 },
  DZ: { symbol: 'د.ج', code: 'dzd', rate: 134.5 },
  EE: { symbol: '€', code: 'eur', rate: 0.92 },
  EG: { symbol: 'E£', code: 'egp', rate: 47.8 },
  ES: { symbol: '€', code: 'eur', rate: 0.92 },
  ET: { symbol: 'Br', code: 'etb', rate: 56.5 },
  FI: { symbol: '€', code: 'eur', rate: 0.92 },
  FJ: { symbol: 'FJ$', code: 'fjd', rate: 2.25 },
  FK: { symbol: '£', code: 'fkp', rate: 0.79 },
  FR: { symbol: '€', code: 'eur', rate: 0.92 },
  GB: { symbol: '£', code: 'gbp', rate: 0.79 },
  GE: { symbol: '₾', code: 'gel', rate: 2.7 },
  GH: { symbol: '₵', code: 'ghs', rate: 14.8 },
  GI: { symbol: '£', code: 'gip', rate: 0.79 },
  GM: { symbol: 'D', code: 'gmd', rate: 67.5 },
  GN: { symbol: 'FG', code: 'gnf', rate: 8600 },
  GR: { symbol: '€', code: 'eur', rate: 0.92 },
  GT: { symbol: 'Q', code: 'gtq', rate: 7.8 },
  GY: { symbol: '$', code: 'gyd', rate: 208.5 },
  HK: { symbol: 'HK$', code: 'hkd', rate: 7.83 },
  HN: { symbol: 'L', code: 'hnl', rate: 24.7 },
  HR: { symbol: '€', code: 'eur', rate: 0.92 },
  HT: { symbol: 'G', code: 'htg', rate: 133 },
  HU: { symbol: 'Ft', code: 'huf', rate: 367 },
  ID: { symbol: 'Rp', code: 'idr', rate: 15900 },
  IE: { symbol: '€', code: 'eur', rate: 0.92 },
  IL: { symbol: '₪', code: 'ils', rate: 3.76 },
  IN: { symbol: '₹', code: 'inr', rate: 83.12 },
  IS: { symbol: 'ISK', code: 'isk', rate: 137.4 },
  IT: { symbol: '€', code: 'eur', rate: 0.92 },
  JM: { symbol: 'J$', code: 'jmd', rate: 154 },
  JO: { symbol: 'JD', code: 'jod', rate: 0.709 },
  JP: { symbol: '¥', code: 'jpy', rate: 153.2 },
  KE: { symbol: 'KSh', code: 'kes', rate: 130.5 },
  KG: { symbol: 'с', code: 'kgs', rate: 89.5 },
  KH: { symbol: '៛', code: 'khr', rate: 4100 },
  KM: { symbol: 'CF', code: 'kmf', rate: 453 },
  KR: { symbol: '₩', code: 'krw', rate: 1385 },
  KW: { symbol: 'د.ك', code: 'kwd', rate: 0.308 },
  KY: { symbol: '$', code: 'kyd', rate: 0.833 },
  KZ: { symbol: '₸', code: 'kzt', rate: 462 },
  LA: { symbol: '₭', code: 'lak', rate: 20650 },
  LB: { symbol: 'ل.ل', code: 'lbp', rate: 89900 },
  LI: { symbol: 'CHF', code: 'chf', rate: 0.91 },
  LK: { symbol: 'Rs', code: 'lkr', rate: 298 },
  LR: { symbol: '$', code: 'lrd', rate: 190 },
  LS: { symbol: 'L', code: 'lsl', rate: 18.9 },
  LT: { symbol: '€', code: 'eur', rate: 0.92 },
  LU: { symbol: '€', code: 'eur', rate: 0.92 },
  LV: { symbol: '€', code: 'eur', rate: 0.92 },
  MA: { symbol: 'د.م.', code: 'mad', rate: 10.05 },
  MD: { symbol: 'L', code: 'mdl', rate: 17.8 },
  MG: { symbol: 'Ar', code: 'mga', rate: 4500 },
  MK: { symbol: 'ден', code: 'mkd', rate: 56.9 },
  MM: { symbol: 'K', code: 'mmk', rate: 2100 },
  MN: { symbol: '₮', code: 'mnt', rate: 3450 },
  MO: { symbol: 'MOP$', code: 'mop', rate: 8.06 },
  MT: { symbol: '€', code: 'eur', rate: 0.92 },
  MU: { symbol: '₨', code: 'mur', rate: 46.3 },
  MV: { symbol: 'Rf', code: 'mvr', rate: 15.4 },
  MW: { symbol: 'MK', code: 'mwk', rate: 1685 },
  MX: { symbol: 'MX$', code: 'mxn', rate: 16.95 },
  MY: { symbol: 'RM', code: 'myr', rate: 4.76 },
  MZ: { symbol: 'MT', code: 'mzn', rate: 63.9 },
  NA: { symbol: '$', code: 'nad', rate: 18.9 },
  NG: { symbol: '₦', code: 'ngn', rate: 1450 },
  NI: { symbol: 'C$', code: 'nio', rate: 36.8 },
  NL: { symbol: '€', code: 'eur', rate: 0.92 },
  NO: { symbol: 'kr', code: 'nok', rate: 10.85 },
  NP: { symbol: '₨', code: 'npr', rate: 133 },
  NZ: { symbol: 'NZ$', code: 'nzd', rate: 1.66 },
  OM: { symbol: 'ر.ع.', code: 'omr', rate: 0.385 },
  PA: { symbol: 'B/.', code: 'pab', rate: 1 },
  PE: { symbol: 'S/', code: 'pen', rate: 3.75 },
  PG: { symbol: 'K', code: 'pgk', rate: 3.75 },
  PH: { symbol: '₱', code: 'php', rate: 57.35 },
  PK: { symbol: '₨', code: 'pkr', rate: 278 },
  PL: { symbol: 'zł', code: 'pln', rate: 4.01 },
  PT: { symbol: '€', code: 'eur', rate: 0.92 },
  PY: { symbol: '₲', code: 'pyg', rate: 7450 },
  QA: { symbol: 'ر.ق', code: 'qar', rate: 3.64 },
  RO: { symbol: 'lei', code: 'ron', rate: 4.6 },
  RS: { symbol: 'дин', code: 'rsd', rate: 108 },
  RU: { symbol: '₽', code: 'rub', rate: 88.5 },
  RW: { symbol: 'FRw', code: 'rwf', rate: 1285 },
  SA: { symbol: 'ر.س', code: 'sar', rate: 3.75 },
  SB: { symbol: '$', code: 'sbd', rate: 8.4 },
  SC: { symbol: '₨', code: 'scr', rate: 14.5 },
  SE: { symbol: 'kr', code: 'sek', rate: 10.48 },
  SG: { symbol: 'S$', code: 'sgd', rate: 1.34 },
  SH: { symbol: '£', code: 'shp', rate: 0.79 },
  SI: { symbol: '€', code: 'eur', rate: 0.92 },
  SK: { symbol: '€', code: 'eur', rate: 0.92 },
  SL: { symbol: 'Le', code: 'sle', rate: 22.5 },
  SO: { symbol: 'Sh', code: 'sos', rate: 570 },
  SR: { symbol: '$', code: 'srd', rate: 36.8 },
  ST: { symbol: 'Db', code: 'std', rate: 22600 },
  SZ: { symbol: 'E', code: 'szl', rate: 18.9 },
  TH: { symbol: '฿', code: 'thb', rate: 36.4 },
  TJ: { symbol: 'ЅМ', code: 'tjs', rate: 10.95 },
  TN: { symbol: 'د.ت', code: 'tnd', rate: 3.14 },
  TO: { symbol: 'T$', code: 'top', rate: 2.38 },
  TR: { symbol: '₺', code: 'try', rate: 32.15 },
  TT: { symbol: 'TT$', code: 'ttd', rate: 6.8 },
  TW: { symbol: 'NT$', code: 'twd', rate: 32.27 },
  TZ: { symbol: 'TSh', code: 'tzs', rate: 2550 },
  UA: { symbol: '₴', code: 'uah', rate: 39.5 },
  UG: { symbol: 'USh', code: 'ugx', rate: 3750 },
  US: { symbol: '$', code: 'usd', rate: 1 },
  UY: { symbol: '$U', code: 'uyu', rate: 39.1 },
  UZ: { symbol: 'som', code: 'uzs', rate: 12450 },
  VN: { symbol: '₫', code: 'vnd', rate: 24600 },
  VU: { symbol: 'VT', code: 'vuv', rate: 119 },
  WS: { symbol: 'WS$', code: 'wst', rate: 2.75 },
  XA: { symbol: 'FCFA', code: 'xaf', rate: 604 },
  XC: { symbol: '$', code: 'xcd', rate: 2.7 },
  XO: { symbol: 'CFA', code: 'xof', rate: 604 },
  XP: { symbol: '₣', code: 'xpf', rate: 110 },
  YE: { symbol: '﷼', code: 'yer', rate: 250 },
  ZA: { symbol: 'R', code: 'zar', rate: 18.9 },
  ZM: { symbol: 'ZK', code: 'zmw', rate: 25.5 },
  USDC: { symbol: 'USDC', code: 'usdc', rate: 1 },
  XCG: { symbol: 'XCG', code: 'xcg', rate: 1 }
};

// Get currency symbol
export const getCurrencySymbol = (countryCode) => {
  return CURRENCY_INFO[countryCode]?.symbol || '$';
};
// Get currency code
export const getCurrencyCode = (countryCode) => {
  return CURRENCY_INFO[countryCode]?.code || 'usd';
};

// Get conversion rate to USD
export const getConversionRate = (countryCode) => {
  return CURRENCY_INFO[countryCode]?.rate || 1;
};

export const getUserCountry = async () => {
  try {
    // Check if country is already stored
    const storedCountry = localStorage.getItem('userCountry');
    if (storedCountry) {
      return storedCountry;
    }

    // Get country from IP API
    const response = await axios.get("https://ipapi.co/json/");
    if (response.data) {
      const countryCode = response.data.country_code;
      localStorage.setItem('userCountry', countryCode);
      return countryCode;
    }
    return 'US'; // Default to US if API fails
  } catch (error) {
    console.error('Error getting user country:', error);
    return 'US'; // Default to US if API fails
  }
};

// export const getCurrencySymbol = (countryCode) => {
//   switch (countryCode) {
//     case 'AE': return 'AED';
//     case 'AR': return 'ARS$';
//     case 'AT': return '€';
//     case 'AU': return 'A$';
//     case 'BE': return '€';
//     case 'BG': return 'лв';
//     case 'BO': return 'Bs';
//     case 'BR': return 'R$';
//     case 'CA': return 'C$';
//     case 'CH': return 'CHF';
//     case 'CL': return 'CLP$';
//     case 'CN': return '¥';
//     case 'CO': return 'COL$';
//     case 'CY': return '€';
//     case 'CZ': return 'Kč';
//     case 'DE': return '€';
//     case 'DK': return 'kr';
//     case 'DO': return 'RD$';
//     case 'EE': return '€';
//     case 'ES': return '€';
//     case 'FI': return '€';
//     case 'FR': return '€';
//     case 'GB': return '£';
//     case 'GR': return '€';
//     case 'HK': return 'HK$';
//     case 'HR': return '€';
//     case 'HU': return 'Ft';
//     case 'ID': return 'Rp';
//     case 'IE': return '€';
//     case 'IL': return '₪';
//     case 'IN': return '₹';
//     case 'IS': return 'ISK';
//     case 'IT': return '€';
//     case 'JP': return '¥';
//     case 'KR': return '₩';
//     case 'LI': return 'CHF';
//     case 'LT': return '€';
//     case 'LU': return '€';
//     case 'LV': return '€';
//     case 'MT': return '€';
//     case 'MX': return 'MX$';
//     case 'MY': return 'RM';
//     case 'NL': return '€';
//     case 'NO': return 'kr';
//     case 'NZ': return 'NZ$';
//     case 'PE': return 'S/';
//     case 'PH': return '₱';
//     case 'PL': return 'zł';
//     case 'PT': return '€';
//     case 'RO': return 'lei';
//     case 'SE': return 'kr';
//     case 'SG': return 'S$';
//     case 'SI': return '€';
//     case 'SK': return '€';
//     case 'TH': return '฿';
//     case 'TR': return '₺';
//     case 'TW': return 'NT$';
//     case 'US': return '$';
//     case 'UY': return '$U';
//     case 'VN': return '₫';
//     case 'ZA': return 'R';
//     default: return '$';
//   }
// };


// Conversion rates (you can update these as needed)

export const getPrice = (product, countryCode) => {
  if (!product) return '0.00';
  
  // Get the base price (individual_price)
  const basePrice = product.individual_price || product.productList?.individual_price || '0.00';
  
  // Convert the price based on country
  const conversionRate = getConversionRate(countryCode) || 1;
  const convertedPrice = parseFloat(basePrice) * conversionRate;
  
  return convertedPrice.toFixed(2);
};

export const formatPrice = (price, countryCode) => {
  if (!price || isNaN(price)) return '0.00';
  const symbol = getCurrencySymbol(countryCode);
  return `${symbol}${parseFloat(price).toFixed(2)}`;
}; 